import { ResponseError } from '../../../errors';
import {
  IGetActiveTypesResponse200,
  TGetActiveTypesResponse,
} from '../../../repositories/infrastructure-caching/v1/get-active-types';

export function assertFetchGetActiveTypesResponse(
  response: TGetActiveTypesResponse,
): asserts response is IGetActiveTypesResponse200 {
  if (response.statusCode !== 200) {
    throw new ResponseError({
      message: response.response.message,
      domain: 'assertFetchGetActiveTypesResponse',
    });
  }
}
